import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface AppState {
  id: string | undefined;
}

const initialState: AppState = { id: undefined };

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setAppId: (state, action: PayloadAction<string>) => {
      state.id = action.payload;
    },
  },
});

export const { setAppId } = appSlice.actions;
export default appSlice.reducer;
